import { render, staticRenderFns } from "./BiLayout.vue?vue&type=template&id=64bbe18c&scoped=true"
import script from "./BiLayout.vue?vue&type=script&lang=js"
export * from "./BiLayout.vue?vue&type=script&lang=js"
import style0 from "./BiLayout.vue?vue&type=style&index=0&id=64bbe18c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bbe18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bbe18c')) {
      api.createRecord('64bbe18c', component.options)
    } else {
      api.reload('64bbe18c', component.options)
    }
    module.hot.accept("./BiLayout.vue?vue&type=template&id=64bbe18c&scoped=true", function () {
      api.rerender('64bbe18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/BiLayout.vue"
export default component.exports